<div class="group1">
  <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Général </h4>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht1">
    <label class="col-sm-3 champ" style="padding:0px">Responsable :
      <!-- <span class="champobligatoire" *ngIf="add"> * </span> -->
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.responsable }}</div>
      <input *ngIf="edit" type="text" class="form-control" id="firstfocus" [(ngModel)]="chantier.responsable">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht2 && !isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px"> N. Chantier :
      <span class="champobligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.numChantier || '-'}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numChantier">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht2 && isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px"> Nom Détenteur :
      <span class="champobligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.numChantier || '-'}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numChantier">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px">Prénom Détenteur :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.prenomDetenteur }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.prenomDetenteur">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px">Tuteur légal :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.tuteurLegal }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.tuteurLegal">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px">Date Naissance :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.dateNaissanceDetenteur }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.dateNaissanceDetenteur"
        (ngModelChange)="common.changeDateFormat('dateNaissanceDetenteur', chantier)">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht3">
    <label class="col-sm-3 champ" style="padding:0px">
      N° Chantier :
      <span class="champobligatoire" *ngIf="societe.isDateChantierObligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.numChantier2 }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numChantier2">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px">Nom 2 :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.nom2 }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.nom2">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px">Prénom 2 :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.prenomDetenteur2 }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.prenomDetenteur2">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="isTypeDetenteur">
    <label class="col-sm-3 champ" style="padding:0px">Date Naissance 2 :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.dateNaissance2 }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.dateNaissance2"
        (ngModelChange)="common.changeDateFormat('dateNaissance2', chantier)">
    </div>
  </div>

  <!--div class="form-group items col-sm-12">
      <label class="col-sm-3 champ" style="padding:0px">Num Badge :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit"> {{ chantier.numBadgeDecheterie }} </div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numBadgeDecheterie">
      </div>
    </div-->
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht4">
    <label class="col-sm-3 champ" style="padding:0px"> Siret :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.siret }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.siret">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht77 && societe.clientCollectivite">
    <label class="col-sm-3 champ" style="padding:0px">
      Date début : 
      <span class="champobligatoire" *ngIf="societe.isDateChantierObligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.dateDebut }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.dateDebut"
        (ngModelChange)="common.changeDateFormat('dateDebut', chantier)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht5">
    <label class="col-sm-3 champ" style="padding:0px">
      Date Fin :
      <span class="champobligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{ chantier.dateFin }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.dateFin"
        (ngModelChange)="common.changeDateFormat('dateFin', chantier)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht6">
    <label class="col-sm-3 champ" style="padding:0px">Tel :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{chantier.telephone}} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.telephone">
    </div>
  </div>

  <ng-template [ngIf]="!adresseAutoBAK || !societe.isBAKRI">
    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
      *ngIf="common.visibleChamp.cht7">
      <label class="col-sm-3 champ" style="padding:0px">Complément 1 :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{chantier.complementAdresse1 || ''}}</div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.complementAdresse1">
      </div>
    </div>
    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
      *ngIf="common.visibleChamp.cht8">
      <label class="col-sm-3 champ" style="padding:0px">Complément 2 :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{chantier.complementAdresse2 || ''}}</div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.complementAdresse2">
      </div>
    </div>
  </ng-template>

  <div class="form-group items col-sm-12"
    *ngIf="common.visibleChamp.cht9 || common.visibleChamp.cht10 || common.visibleChamp.cht11">
    <label class="col-sm-3 champ" style="padding:0px">
      Adresse
      <span class="champobligatoire" > * </span>
      <div class=" text-underline historique" (click)="copieAdresse()"> Dupliquer Ad Client </div>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cht9">{{ chantier.adresse1 }}</div>
      <div *ngIf="!edit && common.visibleChamp.cht10">{{ chantier.adresse2 }}</div>
      <div *ngIf="!edit && common.visibleChamp.cht11">{{ chantier.adresse3 }}</div>
      <div *ngIf="edit && common.visibleChamp.cht9">
        <app-autocomplete *ngIf="adresseAutoBAK" [placeholder]="'Adresse'" (searchfunction)="searchAdresseBAK($event)"
          (selectfunction)="setValueAdresseBAK($event, 'client')" [results]="dataAdresseBAK" [container]="true"
          [defaultsearch]="chantier.adresse1 ? chantier.adresse1 : ''" [minlength]="3" [disablefocus]="true"
          [nePasCompterEspace]="true">
        </app-autocomplete>
        <input *ngIf="edit && !adresseAutoBAK" type="text" class="form-control" [(ngModel)]="chantier.adresse1"
          [readonly]="adresseAutoBAK">
      </div>
      <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.adresse1"  [readonly]="adresseAutoBAK"-->
      <input *ngIf="edit && common.visibleChamp.cht10" type="text" class="form-control" [(ngModel)]="chantier.adresse2"
        [readonly]="adresseAutoBAK" style="margin-top: 5px; margin-bottom: 5px;">
      <input *ngIf="edit && common.visibleChamp.cht11" type="text" class="form-control" [(ngModel)]="chantier.adresse3"
        [readonly]="adresseAutoBAK">
    </div>
  </div>
  <ng-template [ngIf]="adresseAutoBAK && societe.isBAKRI">
    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
      *ngIf="common.visibleChamp.cht7">
      <label class="col-sm-3 champ" style="padding:0px">Batiment :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{chantier.complementAdresse1 || ''}}</div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.complementAdresse1"
          [disabled]="societe.isBAKRI">
      </div>
    </div>
    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
      *ngIf="common.visibleChamp.cht8">
      <label class="col-sm-3 champ" style="padding:0px">Etage :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{chantier.complementAdresse2 || ''}}</div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.complementAdresse2"
          [disabled]="societe.isBAKRI">
      </div>
    </div>
    <div class="form-group col-sm-12" style="cursor: pointer;">
      <label class="col-sm-3 p-0"> Type d'habitat : </label>
      <div class="col-sm-9 disabledbutton">
        <div *ngIf="!edit">{{chantier.typeHabitat ? (chantier.typeHabitat.libelle ||
          chantier.typeHabitat.libelleObjetEntite || '') : ''}}
        </div>
        <app-autocomplete *ngIf="edit" [disablefocus]="true" (selectfunction)="chantier.typeHabitat = $event"
          [results]="[]" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
          [defaultselected]="chantier.typeHabitat"
          [defaultsearch]="chantier.typeHabitat ? (chantier.typeHabitat.libelle || chantier.typeHabitat.libelleObjetEntite) : ''">
        </app-autocomplete>
      </div>
    </div>

    <div class="form-group items col-sm-12">
      <label class="col-sm-3 champ" style="padding:0px">Ref Cadastrale :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{chantier.refCadastrale || ''}}</div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.refCadastrale"
          [disabled]="societe.isBAKRI">
      </div>
    </div>

    <div class="form-group items col-sm-12">
      <label class="col-sm-3 champ" style="padding:0px">Num Invariant :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">{{chantier.numInvariant || ''}}</div>
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numInvariant"
          [disabled]="societe.isBAKRI">
      </div>
    </div>
  </ng-template>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht12">
    <label class="col-sm-3 champ" style="padding:0px">
      CP :
      <span class="champobligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{chantier.codePostal}} </div>
      <div *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'codePostal'" [item]="chantier" [ville]="'ville'" [iscp]="true"
          [disable]="adresseAutoBAK" [cpChantier]="true" (valueChanged)="changerCP($event)">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht13">
    <label class="col-sm-3 champ" style="padding:0px">
      Ville :
      <span class="champobligatoire"> * </span>
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{chantier.ville}} </div>
      <div *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'codePostal'" [item]="chantier" [ville]="'ville'" [disable]="adresseAutoBAK"
          [cpChantier]="true" (valueChanged)="changerCP($event)">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="adresseAutoBAK">
    <label class="col-sm-3 champ" style="padding:0px">
      Ancienne Ville :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{common.bak.ancienneVille}} </div>
      <div *ngIf="edit">
        <app-autocomplete-cp-ville [item]="common.bak" [ville]="'ancienneVille'" [disable]="adresseAutoBAK">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht14">
    <label class="col-sm-3 champ" style="padding:0px"> Pays : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.paysObjet ? chantier.paysObjet.libelle : '' }} </div>
      <div *ngIf="edit">
        <app-autocomplete (searchfunction)="searchPays($event)"
          (selectfunction)="chantier.paysObjet = $event; chantier.pays = $event.libelle;" [results]="result"
          [highlight]="true" [id]="'modedepaie'" [disablefocus]="true" [selectvalue]="true"
          [defaultselected]="chantier.paysObjet" [defaultsearch]="chantier.paysObjet ? chantier.paysObjet.libelle : ''">
        </app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
    *ngIf="common.visibleChamp.cht15">
    <label class="col-sm-3 champ" style="padding:0px"> Zone : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.zone ? chantier.zone.libelle : ''}} </div>
      <div *ngIf="edit" [ngClass]="{'disabledbutton': societe.zoneCommune}">
        <app-autocomplete (searchfunction)="searchZone($event)" (selectfunction)="chantier.zone = $event"
          [results]="resultZone" [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [disablefocus]="true"
          [defaultselected]="chantier.zone" [defaultsearch]="chantier.zone ? chantier.zone.libelle : ''">
        </app-autocomplete>
      </div>
    </div>
  </div>
  
  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
    *ngIf="!societe.clientCollectivite && common.visibleChamp.cht16">
    <label class="col-sm-3 champ" style="padding:0px"> Lieu : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ getValueLieuSelected() }} </div>
      <div class="col-sm-9" style="padding: 0" *ngIf="edit">
        <app-autocomplete (searchfunction)="searchLieu($event)" [results]="rows" [highlight]="true" [id]="'modedepaie'"
          [isCombo]="false" [disablefocus]="true" [notLoading]="true" [defaultselected]="getValueLieuSelected()"
          [defaultsearch]="getValueLieuSelected()" (selectfunction)="setLieuChantierSelect($event);">
        </app-autocomplete>
      </div>
      <div class="col-sm-3" style="padding: 0">
        <div class=" text-underline historique" (click)="searchLieuMAJ();"
          style="padding:  5px 15px; font-size: 13px;"> MAJ </div>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': client && client.prospectHolding }"
    *ngIf="societe.clientCollectivite && common.visibleChamp.cht16">
    <label class="col-sm-3 champ" style="padding:0px"> Circuit : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ getValueLieuSelected() }} </div>
      <div style="padding: 0" *ngIf="edit" 
           [ngClass]="{'col-sm-8': unLieuChantierSelected(), 'col-sm-10': !unLieuChantierSelected()}">
        <app-autocomplete (searchfunction)="searchLieu($event)" [results]="rows" [highlight]="true" [id]="'modedepaie'"
          [isCombo]="false" [disablefocus]="true" [notLoading]="true" [defaultselected]="getValueLieuSelected()"
          [defaultsearch]="getValueLieuSelected()" (selectfunction)="setLieuChantierSelect($event);">
        </app-autocomplete>
      </div>
      
      <div class="text-right" style="padding: 0px;" *ngIf="edit && !add" 
        [ngClass]="{'col-sm-4': unLieuChantierSelected(), 'col-sm-2': !unLieuChantierSelected()}">
        <button class="btn-add-circuit activebtn-circuit" id="add" (click)="ouvrirPanneauMAJCircuit(true)">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
        <button class="btn-add-circuit" id="modif" *ngIf="unLieuChantierSelected()" (click)="ouvrirPanneauMAJCircuit()">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
  
</div>

<ng-template #majLieux>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Gestion des lieux : </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)=" clickfermerMajLieu(); ">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div class="col-sm-12" style="padding: 0; margin-bottom: 5px;">
      <button class="btn-add" (click)="addLigne()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="addLigne()"> Ajouter un lieu </span>
    </div>
    <div class="col-sm-12">
      <ngx-datatable style="height: 100%" class="material cubage" [rows]="rows || []" [columnMode]="'force'"
        [headerHeight]="30" [footerHeight]="0" [rowHeight]="35"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column prop="nom">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Nom </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div class="strong" *ngIf="!row.edit">
              {{value}}
            </div>
            <input *ngIf="row.edit" id="activite{{rowIndex}}" style="padding: 0 10px; height: 25px;" type="text"
              class="form-control" [(ngModel)]="row.nom">
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="150" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-right" style="padding-right: 5px;">
              <button *ngIf="!row.edit" class="btn-detail" (click)="row.edit = !row.edit; showInput(row, rowIndex)">
                <i class="fa fa-pencil"></i>
              </button>
              <button *ngIf="row.edit" class="btn-detail save" (click)="save(row)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>

              <button *ngIf="row.edit" class="btn-detail cancel" (click)="cancel(row)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">

      <button type="button" class=" btn-close" (click)="clickfermerMajLieu();"> Fermer </button>
    </div>
  </div>
</ng-template>

<ng-template #majClefRepartition>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Gestion des clefs de répartition : </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
    
  <div class="modal-body" style="height: auto">
    <div class="form-group items col-sm-12">
      <label class="col-sm-4 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Nom :</label>
      <div class="col-sm-8 champ" style="padding-right: 0px">
        <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.lieuChantierSelect.nom">
      </div>
    </div>
      
    <div class="form-group items col-sm-12">
      <label class="col-sm-4 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Km de référence :</label>
      <div class="col-sm-8 champ" style="padding-right: 0px">
        <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="chantier.lieuChantierSelect.kmRef">
      </div>
    </div>      

    <div class="form-group items col-sm-12">
      <label class="col-sm-4 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Tonnage de référence :</label>
      <div class="col-sm-8 champ" style="padding-right: 0px">
        <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="chantier.lieuChantierSelect.tonnageRef">
      </div>
    </div>      

    <div class="form-group items col-sm-12">
      <label class="col-sm-4 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Consommation de référence :</label>
      <div class="col-sm-8 champ" style="padding-right: 0px">
        <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="chantier.lieuChantierSelect.consoRef">
      </div>
    </div>
    
    <div class="form-group items col-sm-12">
      <label class="col-sm-4 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Temps de référence :</label>
      <div class="col-sm-8 champ" style="padding-right: 0px">
        <input *ngIf="edit" type="time" class="form-control" [(ngModel)]="chantier.lieuChantierSelect.tpsRef">
      </div>
    </div> 
      
    <div class="col-sm-12 maj-clef-repartition">
      <ngx-datatable style="height: 100%" class="material cubage" [rows]="chantier.lieuChantierSelect.listeClesRepartition || []" [columnMode]="'force'"
        [headerHeight]="30" [footerHeight]="0" [rowHeight]="35"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column name="dateDebut">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date début </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              {{ row.dateDebut ? row.dateDebut.slice(0, -9) : '' }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="dateFin">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date fin </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              {{ row.dateFin ? row.dateFin.slice(0, -9) : '' }}
          </ng-template>
        </ngx-datatable-column>        
        
        <ngx-datatable-column [width]="150" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-right" style="padding-right: 5px;">
                <button class="btn-detail" (click)="editLigneClefRepartition(row)" style="margin-right: 7px">
                  <i class="fa fa-pencil"></i>
                </button>                
                
                <button class="btn-detail" (click)="deleteLigneClefRepartition(row)">
                  <i class="fa fa-trash"></i>
                </button>                
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
      
    <div class="col-sm-12" style="padding: 0; margin-bottom: 5px; margin-top: 15px">
      <button class="btn-add" (click)="addLigneClefRepartition()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="addLigne()"> Ajouter une clef de répartition </span>
    </div>      
      
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close" (click)="saveClesRepartition()"> Valider </button>
    </div>
  </div>
</ng-template>

<ng-template #majClefRepartitionVille>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Gestion des répartition ville : </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="chantier.listLieu = rows;common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
    
  <div class="modal-body" style="height: auto">
    <div class="form-group items col-sm-12">
      <label class="col-sm-2 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Date début :</label>
      <div class="col-sm-10 champ" style="padding-right: 0px">
            <app-input-date [class]="'form-control'" [id]="'date'" [model]="clesRepartitionSelected.modelDebut"
              (changefct)="clesRepartitionSelected.modelDebut = $event; changeDateDebut($event, clesRepartitionSelected); showDate = true"
              [placeholder]="'Date debut'"
              (keyenterfct)="common.changeDate($event, clesRepartitionSelected.modelDebut, '#dateF');" [showDatepicker]="true" [closeDatepickerOnSelect]="true">
            </app-input-date>
      </div>
    </div>

    <div class="form-group items col-sm-12">
      <label class="col-sm-2 champ" style="padding:0px; margin-top: 7px; margin-bottom: 15px">Date début :</label>
      <div class="col-sm-10 champ" style="padding-right: 0px">
            <app-input-date [class]="'form-control'" [id]="'date'" [model]="clesRepartitionSelected.modelFin"
              (changefct)="clesRepartitionSelected.modelFin = $event; changeDateFin($event, clesRepartitionSelected); showDate = true"
              [placeholder]="'Date fin'"
              (keyenterfct)="common.changeDate($event, clesRepartitionSelected.modelFin, '#dateF');" [showDatepicker]="true" [closeDatepickerOnSelect]="true">
            </app-input-date>
      </div>
    </div>
      
    <div class="col-sm-12 maj-clef-repartition-ville">
      <ngx-datatable style="height: 100%" class="material cubage" [rows]="clesRepartitionSelected.listeVilleClesRepartition || []" [columnMode]="'force'"
        [headerHeight]="30" [footerHeight]="0" [rowHeight]="35"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column name="circuit" [width]="50">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Circuit </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              {{ clesRepartitionSelected.id || '' }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="codePostalVille" [width]="200">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Ville </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <app-autocomplete (selectfunction)="row.codePostalVille = $event;"
              (searchfunction)="searchCodeVille($event);" [results]="listCodeVille" [highlight]="true"
              [container]="true" [placeholder]="'Commune'" [defaultselected]="row.codePostalVille"
              id="typeOperation comboCpVilleCircuit" [dropdownclass]="'maxZindex'"
              [defaultsearch]="row.codePostalVille ? (row.codePostalVille.label || row.codePostalVille.libelleObjetEntite) : ''">
            </app-autocomplete>
          </ng-template>
        </ngx-datatable-column>        
        
        <ngx-datatable-column name="pourcentage" [width]="100">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Pourcentage </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <input style="padding: 0 10px; height: 25px;" type="number"
              class="form-control" [(ngModel)]="row.pourcentage">
          </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-right" style="padding-right: 5px;">
                <button class="btn-detail" (click)="deleteLigneVilleClefRepartition(row)">
                  <i class="fa fa-trash"></i>
                </button>                
            </div>
          </ng-template>
        </ngx-datatable-column>        
      </ngx-datatable>
    </div>
      
    <div class="col-sm-12" style="padding: 0; margin-bottom: 5px; margin-top: 15px">
      <button class="btn-add" (click)="addLigneVilleClefRepartition()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="addLigne()"> Ajouter une répartition ville </span>
    </div>      
      
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Valider </button>
    </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>